module.exports = __webpack_public_path__ + "static/media/ic_choix.a21225e6.svg";